<template>
  <div class="setting">
    <div class="source">
      <el-form ref="form" label-width="170px">
        
        <el-form-item label="Tyre Pressure Threshold">
          <el-slider
            v-model="tyre_pressure.value_range"
            range
            :max="20"
            :marks="marks">
          </el-slider>
        </el-form-item>

        <el-form-item class="setBtn">
          <el-button type="primary" @click="onSubmit">Setting</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getPressureConfigure, updatePressureConfigure} from "network/setting"

export default {
  name: "setting",
  data() {
    return {
      tyre_pressure: {
        name: "tyre_pressure",
        value_range: [0, 0]
      },
      marks: {
        0: '0',
        5: '5Bar',
        10: '10Bar',
        15: '15Bar',
        20: '20Bar'
      }
    };
  },
  methods: {
    onSubmit() {
      console.log("submit!");
    },
  },
  created() {
    this.getConfigure()
  },
  methods: {
    getConfigure() {
      getPressureConfigure()
        .then(res => {
          if (res.status === 200) {
            this.tyre_pressure = res.data[0]
          }
          
        })
        .catch(err => {
          this.$message.error("Interface error: get_setting_configure");
        })
    },
    onSubmit() {
     updatePressureConfigure(this.tyre_pressure.id, this.tyre_pressure)
        .then((data) => {
          if (data.status === 200) {
            this.getConfigure()

            this.$message({
              message: 'Updated Successfully.',
              type: 'success',
            })
          
          }
        })
        .catch(err => {
          this.$message.error("Interface error: update_setting");
        })
    }
  },
  destroyed() {},
};
</script>

<style scoped>
.setting {
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: .2s;
}
.setting .source {
  padding: 24px;
}

.setting .el-form {
  width: 600px;
}
::v-deep.setting .el-form-item__content{
  margin-left: 190px!important;
}
.setting .setBtn{
  margin-top: 50px;
}
</style>
